import React from "react";
// Accounts-section
import Mr_Pratik_shilimkar from "../../assets/images/academics/faculty/non-teaching-staff/accounts/Mr. Pratik Shilimkar (Account Section 2).jpg";
import Mr_Suraj_Darekar from "../../assets/images/academics/faculty/non-teaching-staff/accounts/Mr. Suraj Darekar (Account Section 1).jpg";
// student-section
import Mrs_Ragini_Datar from "../../assets/images/academics/faculty/non-teaching-staff/student-section/ragini_Datar.jpg";
import Mrs_Pradnya_Salunkhe from "../../assets/images/academics/faculty/non-teaching-staff/student-section/Mrs Pradnya Salunkhe (Student Section 2).jpg";
import Mr_Ravindra_Bhosale from "../../assets/images/academics/faculty/non-teaching-staff/student-section/Ravindra_Bhosale.png";
import Mr_Yogesh_Patil from "../../assets/images/academics/faculty/non-teaching-staff/student-section/yogesh_Patil.png";
//non-teaching-staff
import Mr_Gaurav_Kulkarni from "../../assets/images/academics/faculty/non-teaching-staff/Mr. Gaurav Kulkarni (lab assistant).jpg";
import Mr_Gautam_kote from "../../assets/images/academics/faculty/non-teaching-staff/Mr. Gautam Kote (Peon).jpg";
import Mr_Ramesh_Shedge from "../../assets/images/academics/faculty/non-teaching-staff/Mr. Ramesh Shedge (Poen).jpg";
import Mr_Sanjay_Bhujbal from "../../assets/images/academics/faculty/non-teaching-staff/Mr. Sanjay Bhujbal (Poen).jpg";
import Mrs_Archana_Bhokare from "../../assets/images/academics/faculty/non-teaching-staff/Mrs. Archana Bhoakre (Lab assistant).jpg";
import Mrs_Lata_Khairmode from "../../assets/images/academics/faculty/non-teaching-staff/Mrs. Lata Khairmode (Sweeper).jpg";
import Mrs_Vidya_Pawar from "../../assets/images/academics/faculty/non-teaching-staff/Mrs. Vidya Pawar ( Sweeper).jpg";
import maleProPic from "../../assets/images/academics/faculty/male.png";
import femaleProPic from "../../assets/images/academics/faculty/female.png";
import { Divider, Grid, Paper, Stack, Typography } from "@mui/material";
import ContentLayout from "../../components/ContentLayout";


const Administrative = () => {

  const student_section: ImgProps[] = [
    {
      img: Mrs_Ragini_Datar,
      name: "Mrs. Ragini Datar",
      designation: "Office Superintendent",
    },
    {
      img: Mrs_Pradnya_Salunkhe,
      name: "Mrs. Pradnya Salunkhe",
      designation: "Clerk",
    },
    {
      img: Mr_Ravindra_Bhosale,
      name: "Mr. Ravindra Bhosale",
      designation: "Librarian",
    },
  
    {
      img: Mr_Yogesh_Patil,
      name: "Mr. Yogesh Patil",
      designation: "Technical Head",
    },
  ];
  
  const accounts: ImgProps[] = [
    {
      img: Mr_Suraj_Darekar,
      name: "Mr. Suraj Darekar",
      designation: "Account Incharge",
    },
    {
      img: Mr_Pratik_shilimkar,
      name: "Mr. Pratik Shilimkar",
      designation: "Account Clerk",
    },
  ];


  const non_teaching: ImgProps[] = [
    {
      img: Mrs_Archana_Bhokare,
      name: "Mrs. Archana Bhokare",
      designation: "Lab Assistant",
    },
    {
      img: Mr_Gautam_kote,
      name: "Mr. Gautam Kote",
      designation: "Peon",
    },
    {
      img: Mr_Sanjay_Bhujbal,
      name: "Mr. Sanjay Bhujbal",
      designation: "Peon",
    },
    {
      img: Mr_Ramesh_Shedge,
      name: "Mr. Ramesh Shendge",
      designation: "Peon",
    },
    {
      img: Mr_Gaurav_Kulkarni,
      name: "Mr. Gaurav Kulkarni",
      designation: "Lab Assistant",
    },
    {
      img: maleProPic,
      name: "Mr. Francis Golapalli",
      designation: "",
    },
    {
      img: Mrs_Lata_Khairmode,
      name: "Mrs. Lata Khairmode",
      designation: "Sweeper",
    },
    {
      img: Mrs_Vidya_Pawar,
      name: "Mrs. Vidya Pawar",
      designation: "Sweeper",
    },
    {
      img: femaleProPic,
      name: "Mrs. Surekha Kamble",
      designation: "",
    },
  ];

  const allData = new Map([
    ["Student Section", student_section],
    ["Accounts Section", accounts],
    ["Non-Teaching Staff", non_teaching],
  ]);

  return (
    <ContentLayout
      children={
        <Stack
          sx={{ backgroundColor: "primary.light", p: { xs: 1, md: 3 } }}
          spacing={4}
          direction="column"
          alignItems="center"
          justifyContent="center"
        >
          {Array.from(allData.entries()).map(
            ([departmentName, facultyMembers], i) => {
              return (
                <React.Fragment key={departmentName + i}>
                  {i > 0 && (
                    <Divider
                      sx={{
                        my: 2,
                        width: "100%",
                        borderBottom: "5px dotted #002147",
                      }}
                    />
                  )}

                  <Typography
                    id={departmentName}
                    variant="h4"
                    sx={{
                      textAlign: "left",
                      alignSelf: "baseline",
                      textDecoration: "underline",
                      textUnderlineOffset: "6px",
                    }}
                  >
                    {departmentName}
                  </Typography>

                  <Grid container columns={{ xs: 1, sm: 2, md: 4 }} spacing={2}>
                    {facultyMembers?.length > 0 ? (
                      facultyMembers.map((current, i) => (
                        <Grid item xs={1}>
                          <Img {...current} />
                        </Grid>
                      ))
                    ) : (
                      <Typography
                        variant="h6"
                        sx={{ width: "100%", textAlign: "center" }}
                      >
                        ... will update soon
                      </Typography>
                    )}
                  </Grid>
                </React.Fragment>
              );
            }
          )}
        </Stack>
      }
    />
  );
};
interface ImgProps {
  img: string;
  name: string;
  designation: string;
}

const Img = ({ img, name, designation }: ImgProps) => {
  return (
    <Paper
      sx={{
        maxHeight: { xs: 300 },
        minHeight: { xs: 300 },
        overflow: "auto",
      }}
    >
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="center"
        p={1}
      >
        <img
          src={img}
          width="200px"
          height="200px"
          alt="Faculties"
          style={{ objectFit: "contain" }}
        />
        <Typography color="primary.main" mt={2}>
          <span style={{ fontWeight: "bold" }}>Name:&nbsp;</span>
          {name}
        </Typography>
        <Typography color="primary.main" noWrap>
          <span style={{ fontWeight: "bold" }}>Designation:&nbsp;</span>
          {designation}
        </Typography>
      </Stack>
    </Paper>
  );
};

export default Administrative;
